var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 20.5C4.2 20.5 3.72933 20.3043 3.338 19.913C2.94667 19.5217 2.75067 19.0507 2.75 18.5V6.5C2.75 5.95 2.946 5.47933 3.338 5.088C3.73 4.69667 4.20067 4.50067 4.75 4.5H20.75C21.3 4.5 21.771 4.696 22.163 5.088C22.555 5.48 22.7507 5.95067 22.75 6.5V18.5C22.75 19.05 22.5543 19.521 22.163 19.913C21.7717 20.305 21.3007 20.5007 20.75 20.5H4.75ZM12.75 13.325C12.8333 13.325 12.921 13.3123 13.013 13.287C13.105 13.2617 13.1923 13.2243 13.275 13.175L20.35 8.75C20.4833 8.66667 20.5833 8.56267 20.65 8.438C20.7167 8.31333 20.75 8.17567 20.75 8.025C20.75 7.69167 20.6083 7.44167 20.325 7.275C20.0417 7.10833 19.75 7.11667 19.45 7.3L12.75 11.5L6.05 7.3C5.75 7.11667 5.45833 7.11267 5.175 7.288C4.89167 7.46333 4.75 7.709 4.75 8.025C4.75 8.19167 4.78333 8.33767 4.85 8.463C4.91667 8.58833 5.01667 8.684 5.15 8.75L12.225 13.175C12.3083 13.225 12.396 13.2627 12.488 13.288C12.58 13.3133 12.6673 13.3257 12.75 13.325Z",
    fill: "#3B54A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/Email-Icon.ab0028df6fbf2f4b4391f5af2b52504d.svg";
export { ForwardRef as ReactComponent };